/**
 * Off-site destinations, in one place.
 *
 * Small, but worth existing: the same account gets linked from the header and
 * the footer, and a handle that is right in one and stale in the other is the
 * ordinary way these go wrong.
 */
export const SOCIALS = {
  x: 'https://x.com/elyxrxyz',
  telegram: 'https://t.me/Elyxrxyz',
} as const

/** Derived from the URLs, so a handle and its link cannot drift apart. */
export const X_HANDLE = `@${SOCIALS.x.split('/').pop()}`
export const TELEGRAM_HANDLE = `@${SOCIALS.telegram.split('/').pop()}`
